<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter">
            <h3>{{ title }}</h3>
            <div class="stylesoption align-center">
                <img :src="'/images/hallmark/fitting-kit.png'" />
            </div>
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>Fitting Pack required?</span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Fitting Pack';
                }
            },
            component_id: {
                default(){
                    return 'fitting_pack';
                }
            }
        },
        computed: {
            passed_filter(){
                return true;
            },
            url(){
                return '/api/options/' + this.fabricator + '/fitting-pack';
            },
            cache_key(){
                return '_';
            },
        },
        watch: {

        }
    }
</script>
